var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2086 14.4998L28.6459 2.06243C28.8661 1.83453 28.9878 1.5293 28.9851 1.21248C28.9823 0.895661 28.8553 0.592596 28.6312 0.368561C28.4072 0.144526 28.1041 0.0174472 27.7873 0.0146941C27.4705 0.011941 27.1653 0.133734 26.9374 0.353842L14.5 12.7912L2.06261 0.353842C1.83472 0.133734 1.52949 0.011941 1.21267 0.0146941C0.895847 0.0174472 0.592782 0.144526 0.368747 0.368561C0.144712 0.592596 0.0176331 0.895661 0.01488 1.21248C0.0121269 1.5293 0.13392 1.83453 0.354028 2.06243L12.7914 14.4998L0.354028 26.9372C0.1275 27.1638 0.000244141 27.4711 0.000244141 27.7915C0.000244141 28.1119 0.1275 28.4192 0.354028 28.6458C0.580624 28.8723 0.887913 28.9995 1.20832 28.9995C1.52873 28.9995 1.83602 28.8723 2.06261 28.6458L14.5 16.2084L26.9374 28.6458C27.164 28.8723 27.4712 28.9995 27.7917 28.9995C28.1121 28.9995 28.4193 28.8723 28.6459 28.6458C28.8725 28.4192 28.9997 28.1119 28.9997 27.7915C28.9997 27.4711 28.8725 27.1638 28.6459 26.9372L16.2086 14.4998Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.899359f076e6aca3f4a7d9bb2de59c37.svg";
export { ForwardRef as ReactComponent };